import { render, staticRenderFns } from "./ListaConceptos.vue?vue&type=template&id=87454100&"
import script from "./ListaConceptos.vue?vue&type=script&lang=js&"
export * from "./ListaConceptos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports